'use client';
import { useState } from 'react';
import Image from 'next/image';
import { Card } from '@/components/ui/card';
import type { Photo } from '@/lib/types';
import { PhotoViewer } from './photo-viewer';

interface PhotoCardProps {
  photo: Photo;
}

export function PhotoCard({ photo }: PhotoCardProps) {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  return (
    <>
      <Card
        className="overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300 animate-in fade-in zoom-in-95 cursor-pointer"
        onClick={() => setIsViewerOpen(true)}
      >
        <div className="aspect-square relative">
          <Image
            src={photo.thumbnailUrl || photo.imageUrl}
            alt={`Photo from event ${photo.eventId}`}
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
      </Card>
      {isViewerOpen && (
        <PhotoViewer
          photo={photo}
          isOpen={isViewerOpen}
          onOpenChange={setIsViewerOpen}
        />
      )}
    </>
  );
}
